//Get allowed countries
export const GET_ALLOWED_COUNTRIES = "GET_ALLOWED_COUNTRIES";

//Loading flag while a get/save request is in flight
export const SET_ALLOWED_COUNTRIES_LOADING = "SET_ALLOWED_COUNTRIES_LOADING";

//Request failed
export const ALLOWED_COUNTRIES_ERROR = "ALLOWED_COUNTRIES_ERROR";
